import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

const defaultOptions = {
  // Empty baseURL keeps requests relative, so they hit whatever origin serves the app.
  baseURL: process.env.REACT_APP_BACKEND || '',
  method: 'get' as const,
  headers: {
    'Content-Type': 'application/json',
  },
};

// Create instance
const instance: AxiosInstance = axios.create(defaultOptions);

// Set the AUTH token for any request
instance.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const token = localStorage.getItem('SavedToken');
    config.headers.Authorization = token ? token : '';
    return config;
  }
);

export default instance;